"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var model_1 = require("@/pages/developments/states/model");
var model_2 = require("./states/model");
var MegaMenu_1 = require("../common/components/MegaMenu");
var DevelopmentPageAssetPurpose_1 = require("./states/model/DevelopmentPageAssetPurpose");
var SocialMediaShareButton_1 = require("./components/SocialMediaShareButton");
var ContactUsButton_1 = require("./components/ContactUsButton");
var WhatsAppUsButton_1 = require("./components/WhatsAppUsButton");
var react_html_parser_1 = require("react-html-parser");
var Enquire_1 = require("../common/components/Enquire");
var Bigpopup_1 = require("../common/components/Bigpopup");
var MegaMenuSide_1 = require("../common/components/MegaMenuSide");
var NearbymapState_1 = require("../common/states/NearbymapState");
var MapObject_1 = require("../detail/components/MapObject");
var myokay_map2_1 = require("@okay/myokay-map2");
var DetailPopup_1 = require("../detail/components/DetailPopup");
var DetailGalleryState_1 = require("../detail/states/DetailGalleryState");
var DetailAction_1 = require("../detail/actions/DetailAction");
var NearbyAction_1 = require("../detail/actions/NearbyAction");
var VideoAction_1 = require("../detail/actions/VideoAction");
var DetailGalleryAction_1 = require("../detail/actions/DetailGalleryAction");
var React = require("react");
var PhotoGalleryAction_1 = require("./actions/PhotoGalleryAction");
var react_swipeable_1 = require("react-swipeable");
exports.mapDispatchToProps = function (dispatch) { return ({
    closePopup: function () { return dispatch(DetailAction_1.default.closePopup()); },
    onMenuItemClick: function (type) { return dispatch(DetailAction_1.default.onMenuItemClick(type)); },
    onGridImageClick: function (id, i, photo) { return dispatch(DetailAction_1.default.onGridImageClick(id, i, photo)); },
    onBackClick: function () { return dispatch(DetailAction_1.default.onBackClick()); },
    onMapObjectClick: function (object, i) { return dispatch(NearbyAction_1.default.onMapObjectClick(object, i)); },
    onMarkerClick: function (object, i) { return dispatch(NearbyAction_1.default.onMarkerClick(object, i)); },
    onMapObjectsClick: function (objects) { return dispatch(NearbyAction_1.default.onMapObjectsClick(objects)); },
    onFilterClick: function (filterType) { return dispatch(NearbyAction_1.default.onFilterClick(filterType)); },
    onMoreClick: function () { return dispatch(NearbyAction_1.default.onMoreClick()); },
    onPlaylistClick: function (video) { return dispatch(VideoAction_1.default.onPlaylistClick(video)); },
    onMyPlacesClick: function () { return dispatch(DetailAction_1.default.onMyPlaceClick()); },
    onAddPlaceClick: function () { return dispatch(NearbyAction_1.default.onAddPlaceClick()); },
    onMyPlaceClick: function (item, i) { return dispatch(NearbyAction_1.default.onMyPlaceClick(item, i)); },
    onPlayerClick: function () { return dispatch(VideoAction_1.default.onPlayerClick()); },
    onPlayToggle: function () { return dispatch(VideoAction_1.default.onPlayToggle()); },
    onMutedToggle: function () { return dispatch(VideoAction_1.default.onMutedToggle()); },
    onChangeStart: function () { return dispatch(VideoAction_1.default.onChangeStart()); },
    onChange: function (newCurrent) { return dispatch(VideoAction_1.default.onChange(newCurrent)); },
    onChangeEnd: function (newCurrent) { return dispatch(VideoAction_1.default.onChangeEnd(newCurrent)); },
    onSlidePrevClick: function (id) {
        return dispatch(PhotoGalleryAction_1.default.onSlidePrevClick(id));
    },
    onSlideNextClick: function (id) {
        return dispatch(PhotoGalleryAction_1.default.onSlideNextClick(id));
    },
    onSlideClick: function (id, i, slide) {
        return dispatch(DetailGalleryAction_1.default.onSlideClick(id, i, slide));
    },
    onMapViewClick: function () { },
    onStreetViewClick: function () { },
    onViewFloorPlanClick: function () { },
    onViewPhotoClick: function () { },
}); };
var mapStateToProps = function (state) {
    return __assign(__assign(__assign(__assign({}, state), state.development), state.detailPopup), { lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, imgDomain: state.layout.imgDomain, googleApi: state.layout.googleApi, isMortgageExpand: false, hasVr: false, hasFloorPlan: false, showPanel: false, t: state.development.t });
};
var development = function (props) {
    var developmentDetails = props.developmentDetails, imgDomain = props.imgDomain, t = props.t, detailPopup = props.detailPopup;
    var _a = react_1.useState(false), isPhotoGalleryRendered = _a[0], setIsPhotoGalleryRendered = _a[1];
    var photoGalleryPanelRef = react_1.useRef(null);
    var videoGalleryPanelRef = react_1.useRef(null);
    var mapContainerPanelRef = react_1.useRef(null);
    var photoGalleryRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (photoGalleryRef.current.offsetHeight) {
            setIsPhotoGalleryRendered(true);
        }
    }, [photoGalleryRef.current]);
    var concatenatedDeveloperNames = developmentDetails.developers
        .map(function (developer) { return developer.developerName; })
        .join(' / ');
    ;
    var address = developmentDetails.addresses[0].thoroughfare + ', ' + developmentDetails.addresses[0].localityName;
    var getPhotos = function (developmentAssets, assetPurpose, categoryId) {
        var photos = developmentAssets.filter(function (asset) { return (asset.categoryId === categoryId && (asset.purposeFlag & assetPurpose) == assetPurpose); })
            .map(function (asset, index) { return ({
            urlSmall: "" + imgDomain + asset.fileLocation + "small/" + asset.resourceText + "." + asset.fileExtension,
            urlMedium: "" + imgDomain + asset.fileLocation + "medium/" + asset.resourceText + "." + asset.fileExtension,
            urlLarge: "" + imgDomain + asset.fileLocation + "large/" + asset.resourceText + "." + asset.fileExtension,
            name: asset.assetName,
            index: index
        }); });
        return photos;
    };
    var renderBanner = function () {
        var photo = getPhotos(developmentDetails.assets, DevelopmentPageAssetPurpose_1.AssetPurpose.HeroInDetailsPage, 999)[0];
        return (React.createElement("div", { className: "c-development__bannerContainer" },
            React.createElement("div", { className: "c-development__banner-bg c-development__banner__overlay" }, React.createElement("picture", { className: 'c-development__picture' },
                React.createElement("source", { srcSet: photo ? photo.urlSmall : '', media: "(max-width: 520px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlMedium : '', media: "(max-width: 768px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlLarge : '' }),
                React.createElement("img", { src: photo ? photo.urlMedium : '', alt: photo ? photo.name : '', loading: "lazy" }))),
            React.createElement("div", { className: "c-development__banner__info" },
                React.createElement("div", { className: "c-development__banner__title" }, developmentDetails.developmentName))));
    };
    var renderAddressAndDevelopers = function () {
        return (React.createElement("div", { className: 'c-development__addressAndDeveloperContainer' },
            React.createElement("div", { className: 'c-development__addressContainer' },
                React.createElement("i", { className: "fas fa-map-marker-alt" }),
                React.createElement("span", { className: "c-development__address" }, address)),
            React.createElement("div", { className: 'c-development__developersContainer' },
                React.createElement("i", { className: "fas fa-building" }),
                React.createElement("span", { className: "c-development__developer" }, concatenatedDeveloperNames))));
    };
    var renderpPojectInformation = function () {
        return (React.createElement("div", { className: 'c-development__projectInformationContainer' },
            React.createElement("div", { className: 'c-development__projectInformation-text' }, developmentDetails.projectInformation)));
    };
    var photos = getPhotos(developmentDetails.assets, DevelopmentPageAssetPurpose_1.AssetPurpose.Gallery, 999);
    var galleryItems = [{
            type: DetailGalleryState_1.DetailGalleryItemType.IMAGE,
            thumb: '',
            src: photos && photos.length > 0 ? photos[0].urlLarge : '',
            title: photos && photos.length > 0 ? photos[0].name : '',
        }];
    var renderPhotoGallery = function () {
        var showPhoto1 = photos && photos.length > 0;
        var showPhoto2 = photos && photos.length > 1;
        var showPhoto3 = photos && photos.length > 2;
        var showPhoto4 = photos && photos.length > 3;
        var showPhoto5 = photos && photos.length > 4;
        var showSpan = showPhoto1 || showPhoto2 || showPhoto3 || showPhoto4 || showPhoto5;
        var onSlideClick = function () { return props.onSlideClick('detailgallery', 0, galleryItems[0]); };
        var _a = react_1.useState(0), currentPhotoIndex = _a[0], setCurrentPhotoIndex = _a[1];
        var _b = react_1.useState(false), isDragging = _b[0], setIsDragging = _b[1];
        var _c = react_1.useState(0), startX = _c[0], setStartX = _c[1];
        var _d = react_1.useState(false), isPaused = _d[0], setIsPaused = _d[1];
        var timeoutRef = react_1.useRef(null);
        var onSlidePrevClick = function (event) {
            event.stopPropagation();
            setCurrentPhotoIndex(function (prevIndex) { return (prevIndex > 0 ? prevIndex - 1 : photos.length - 1); });
        };
        var onSlideNextClick = function (event) {
            event.stopPropagation();
            setCurrentPhotoIndex(function (prevIndex) { return (prevIndex < photos.length - 1 ? prevIndex + 1 : 0); });
        };
        var handleMouseDown = function (event) {
            setIsDragging(true);
            setStartX(event.clientX);
        };
        var handleMouseMove = function (event) {
            if (!isDragging)
                return;
            var currentX = event.clientX;
            var diffX = startX - currentX;
            if (diffX > 50) {
                setCurrentPhotoIndex(function (prevIndex) { return (prevIndex < photos.length - 1 ? prevIndex + 1 : 0); });
                setIsDragging(false);
            }
            else if (diffX < -50) {
                setCurrentPhotoIndex(function (prevIndex) { return (prevIndex > 0 ? prevIndex - 1 : photos.length - 1); });
                setIsDragging(false);
            }
        };
        var handleMouseUp = function () {
            setIsDragging(false);
        };
        var handleMouseEnter = function () {
            setIsPaused(true);
        };
        var handleMouseLeave = function () {
            setIsPaused(false);
        };
        react_1.useEffect(function () {
            if (isDragging) {
                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
            }
            else {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
            }
            return function () {
                window.removeEventListener('mousemove', handleMouseMove);
                window.removeEventListener('mouseup', handleMouseUp);
            };
        }, [isDragging]);
        react_1.useEffect(function () {
            if (!isPaused) {
                var interval_1 = setInterval(function () {
                    setCurrentPhotoIndex(function (prevIndex) { return (prevIndex < photos.length - 1 ? prevIndex + 1 : 0); });
                }, 3000); // Change slide every 3 seconds
                return function () { return clearInterval(interval_1); };
            }
        }, [isPaused, photos.length]);
        var handleManualChange = function (newIndex) {
            setCurrentPhotoIndex(newIndex);
            setIsPaused(true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(function () {
                setIsPaused(false);
            }, 10000);
        };
        var swipeHandlers = react_swipeable_1.useSwipeable({
            onSwipedLeft: function () { return handleManualChange(function (prevIndex) { return (prevIndex < photos.length - 1 ? prevIndex + 1 : 0); }); },
            onSwipedRight: function () { return handleManualChange(function (prevIndex) { return (prevIndex > 0 ? prevIndex - 1 : photos.length - 1); }); },
            preventScrollOnSwipe: true,
            trackMouse: true
        });
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'c-development__photoGallery', onClick: onSlideClick, ref: photoGalleryRef },
                React.createElement("div", { className: 'c-development__photoGallery-left', onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
                    React.createElement("div", __assign({ className: 'c-development__photoGallery-photo', onMouseDown: handleMouseDown }, swipeHandlers),
                        showPhoto1 && (React.createElement("picture", { className: 'c-development__picture' },
                            React.createElement("source", { srcSet: photos && photos.length > currentPhotoIndex ? photos[currentPhotoIndex].urlSmall : '', media: "(max-width: 520px)" }),
                            React.createElement("source", { srcSet: photos && photos.length > currentPhotoIndex ? photos[currentPhotoIndex].urlMedium : '', media: "(max-width: 768px)" }),
                            React.createElement("source", { srcSet: photos && photos.length > currentPhotoIndex ? photos[currentPhotoIndex].urlLarge : '' }),
                            React.createElement("img", { src: photos && photos.length > currentPhotoIndex ? photos[currentPhotoIndex].urlLarge : '', alt: photos && photos.length > currentPhotoIndex ? photos[currentPhotoIndex].name : '', loading: "lazy" }))),
                        React.createElement("div", { className: 'c-development__photoGallery-arrow-container' },
                            React.createElement("div", { className: "c-development__photoGallery-arrow c-development__photoGallery-left-arrow", onClick: onSlidePrevClick },
                                React.createElement("i", { className: "fal fa-chevron-left" })),
                            React.createElement("div", { className: "c-development__photoGallery-arrow c-development__photoGallery-right-arrow", onClick: onSlideNextClick },
                                React.createElement("i", { className: "fal fa-chevron-right" }))))),
                React.createElement("div", { className: "c-development__photoGallery-right" },
                    React.createElement("div", { className: "c-development__photoGallery-row" },
                        showPhoto2 && (React.createElement("picture", { className: 'c-development__picture' },
                            React.createElement("source", { srcSet: photos[1].urlSmall, media: "(max-width: 600px)" }),
                            React.createElement("source", { srcSet: photos[1].urlMedium, media: "(max-width: 1200px)" }),
                            React.createElement("source", { srcSet: photos[1].urlLarge }),
                            React.createElement("img", { src: photos[1].urlLarge, alt: photos[1].name, loading: "lazy" }))),
                        showPhoto3 && (React.createElement("picture", { className: 'c-development__picture' },
                            React.createElement("source", { srcSet: photos[2].urlSmall, media: "(max-width: 600px)" }),
                            React.createElement("source", { srcSet: photos[2].urlMedium, media: "(max-width: 1200px)" }),
                            React.createElement("source", { srcSet: photos[2].urlLarge }),
                            React.createElement("img", { src: photos[2].urlLarge, alt: photos[2].name, loading: "lazy" })))),
                    React.createElement("div", { className: "c-development__photoGallery-row" },
                        showPhoto4 && (React.createElement("picture", { className: 'c-development__picture' },
                            React.createElement("source", { srcSet: photos[3].urlSmall, media: "(max-width: 600px)" }),
                            React.createElement("source", { srcSet: photos[3].urlMedium, media: "(max-width: 1200px)" }),
                            React.createElement("source", { srcSet: photos[3].urlLarge }),
                            React.createElement("img", { src: photos[3].urlLarge, alt: photos[3].name, loading: "lazy" }))),
                        React.createElement("div", { className: "c-development__photoGallery-photoWithSpan" },
                            showSpan && React.createElement("span", { className: "c-development__photoGallery-span" }, t.seeAllPhotos),
                            showPhoto5 && (React.createElement("picture", { className: 'c-development__picture' },
                                React.createElement("source", { srcSet: photos[4].urlSmall, media: "(max-width: 600px)" }),
                                React.createElement("source", { srcSet: photos[4].urlMedium, media: "(max-width: 1200px)" }),
                                React.createElement("source", { srcSet: photos[4].urlLarge }),
                                React.createElement("img", { src: photos[4].urlLarge, alt: photos[4].name, loading: "lazy" })))))))));
    };
    var getVideo = function (developmentAssets) {
        var video = developmentAssets.filter(function (asset) { return (asset.assetType == model_1.AssetType.Video); })
            .map(function (asset) { return ({
            url: "" + asset.fileLocation,
            name: asset.resourceText
        }); })[0];
        return video;
    };
    var video = getVideo(developmentDetails.assets);
    var showVideo = video ? true : false;
    var renderVideoGallery = function () {
        return (React.createElement("div", { className: 'c-development__videoGallery' },
            React.createElement("div", { className: "video-overlay" }),
            React.createElement("iframe", { className: 'c-development__videoGallery-iframe', ref: videoGalleryPanelRef, src: video ? video.url + '?autoplay=0&mute=0&loop=1&controls=0&modestbranding=0&playsinline=1&rel=0&enablejsapi=1' : null, title: video ? video.name : null, frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;", allowFullScreen: true })));
    };
    var renderMapContainer = function () {
        var renderMap = function (config) {
            var renderObject = function (object, i) {
                return MapObject_1.renderMapObject(object, i, function () { }, function () { }, function () { });
            };
            return config.objects && config.objects.length ? (React.createElement(myokay_map2_1.GoogleMap, __assign({}, config.mapState), config.objects.map(renderObject))) : null;
        };
        var addresses = developmentDetails.addresses;
        var mapObjects = addresses.map(function (address, index) {
            var lat = address.latitude;
            var lng = address.longitude;
            var titlePostfix = index > 0 ? " - " + (index + 1) : '';
            return [
                { kind: NearbymapState_1.NearbymapObjectKind.MARKER, center: { lat: lat, lng: lng }, active: true, icon: 'firsthand-property' },
                { kind: NearbymapState_1.NearbymapObjectKind.PIN, center: { lat: lat, lng: lng }, title: "" + developmentDetails.developmentName + titlePostfix, active: true }
            ];
        }).flat();
        var config = {
            mapState: {
                center: { lat: addresses[0].latitude, lng: addresses[0].longitude },
                zoom: 20
            },
            objects: mapObjects
        };
        return (React.createElement("div", { className: 'c-development__mapWrapper', ref: mapContainerPanelRef }, renderMap(config)));
    };
    var adjustPanelHeights = function () {
        if (!photoGalleryPanelRef.current || (!videoGalleryPanelRef.current && !mapContainerPanelRef.current)) {
            return;
        }
        var height = photoGalleryPanelRef.current.offsetHeight;
        if (!height)
            return;
        if (videoGalleryPanelRef.current)
            videoGalleryPanelRef.current.style.height = height + "px";
        if (mapContainerPanelRef.current)
            mapContainerPanelRef.current.style.height = height + "px";
    };
    var renderMultimedia = function () {
        var _a = react_1.useState('tab-photoGallery'), selectedTab = _a[0], setSelectedTab = _a[1];
        var handleTabChange = function (event) {
            setSelectedTab(event.target.value);
        };
        react_1.useEffect(function () {
            if (isPhotoGalleryRendered) {
                adjustPanelHeights();
            }
            window.addEventListener('resize', adjustPanelHeights);
            return function () {
                window.removeEventListener('resize', adjustPanelHeights);
            };
        }, [isPhotoGalleryRendered]);
        return (React.createElement("div", { className: 'c-development__multimediaContainer' },
            React.createElement("div", { className: "c-development__multimedia-tab-container" },
                React.createElement("input", { type: "radio", name: "tabGallery", id: "tab-photoGallery", value: "tab-photoGallery", checked: selectedTab === 'tab-photoGallery', onChange: handleTabChange }),
                showVideo && React.createElement("input", { type: "radio", name: "tabGallery", id: "tab-videoGallery", value: "tab-videoGallery", checked: selectedTab === 'tab-videoGallery', onChange: handleTabChange }),
                React.createElement("input", { type: "radio", name: "tabGallery", id: "tab-mapContainer", value: "tab-mapContainer", checked: selectedTab === 'tab-mapContainer', onChange: handleTabChange }),
                React.createElement("div", { className: "c-development__multimedia-tab-menu-container" },
                    React.createElement("div", { className: 'c-development__multimedia-tab-menu' },
                        React.createElement("label", { htmlFor: "tab-photoGallery" }, t.photoGallery)),
                    showVideo && React.createElement("div", { className: 'c-development__multimedia-tab-menu' },
                        React.createElement("label", { htmlFor: "tab-videoGallery" }, t.videoGallery)),
                    React.createElement("div", { className: 'c-development__multimedia-tab-menu' },
                        React.createElement("label", { htmlFor: "tab-mapContainer" }, t.mapContainer))),
                React.createElement("div", { className: "c-development__multimedia-tab-content" },
                    React.createElement("div", { className: "c-development__multimedia-tab-panel-wrapper", id: "photoGallery-panel", ref: photoGalleryPanelRef }, renderPhotoGallery()),
                    showVideo && React.createElement("div", { className: "c-development__multimedia-tab-panel-wrapper", id: "videoGallery-panel" }, renderVideoGallery()),
                    React.createElement("div", { className: "c-development__multimedia-tab-panel-wrapper", id: "mapContainer-panel" }, renderMapContainer())))));
    };
    var salesBrochuresPanel = developmentDetails.tabPanels.filter(function (it) { return it.tabType === model_2.TabType.SalesBrochures; })[0];
    var floorPlanPanel = developmentDetails.tabPanels.filter(function (it) { return it.tabType === model_2.TabType.FloorPlans; })[0];
    var priceListPanel = developmentDetails.tabPanels.filter(function (it) { return it.tabType === model_2.TabType.PriceList; })[0];
    var salesArrangementPanel = developmentDetails.tabPanels.filter(function (it) { return it.tabType === model_2.TabType.SalesArrangement; })[0];
    var registerOfTransactionsPanel = developmentDetails.tabPanels.filter(function (it) { return it.tabType === model_2.TabType.RegisterOfTransactions; })[0];
    var renderDocumentTabs = function () {
        var _a = react_1.useState(''), selectedTab = _a[0], setSelectedTab = _a[1];
        var handleTabChange = function (event) {
            setSelectedTab(event.target.value);
        };
        var tabMenuRef = react_1.useRef(null);
        var _b = react_1.useState(false), showLeftArrow = _b[0], setShowLeftArrow = _b[1];
        var _c = react_1.useState(false), showRightArrow = _c[0], setShowRightArrow = _c[1];
        var updateArrows = function () {
            if (tabMenuRef.current) {
                var _a = tabMenuRef.current, scrollLeft_1 = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
                setShowLeftArrow(scrollLeft_1 > 0);
                setShowRightArrow(scrollLeft_1 + clientWidth < scrollWidth);
            }
        };
        var scrollLeft = function () {
            if (tabMenuRef.current) {
                tabMenuRef.current.scrollBy({ left: -200, behavior: 'smooth' });
            }
        };
        var scrollRight = function () {
            if (tabMenuRef.current) {
                tabMenuRef.current.scrollBy({ left: 200, behavior: 'smooth' });
            }
        };
        var isEmptyBodyPanels = function (panel) {
            if (!panel || !panel.table)
                return false;
            return panel.table.body.length === 0;
        };
        react_1.useEffect(function () {
            updateArrows();
            if (tabMenuRef.current) {
                tabMenuRef.current.addEventListener('scroll', updateArrows);
            }
            return function () {
                if (tabMenuRef.current) {
                    tabMenuRef.current.removeEventListener('scroll', updateArrows);
                }
            };
        }, []);
        return React.createElement("div", { className: "c-development__documentContainer" },
            React.createElement("div", { className: "tab-container" },
                React.createElement("input", { type: "radio", name: "tab", id: "tab1", value: "tab1", checked: selectedTab === 'tab1', onChange: handleTabChange }),
                React.createElement("input", { type: "radio", name: "tab", id: "tab2", value: "tab2", checked: selectedTab === 'tab2', onChange: handleTabChange }),
                React.createElement("input", { type: "radio", name: "tab", id: "tab3", value: "tab3", checked: selectedTab === 'tab3', onChange: handleTabChange }),
                React.createElement("input", { type: "radio", name: "tab", id: "tab4", value: "tab4", checked: selectedTab === 'tab4', onChange: handleTabChange }),
                React.createElement("input", { type: "radio", name: "tab", id: "tab5", value: "tab5", checked: selectedTab === 'tab5', onChange: handleTabChange }),
                React.createElement("div", { className: "tab-menu-container" },
                    React.createElement("i", { className: "arrow left-arrow " + (showLeftArrow ? '' : 'hidden'), onClick: scrollLeft }),
                    React.createElement("div", { className: "tab-menu", ref: tabMenuRef },
                        React.createElement("div", { className: 'tab-item' },
                            React.createElement("i", { className: "fas fa-book-open" }),
                            React.createElement("label", { htmlFor: "tab1" }, t.salesBrochures)),
                        React.createElement("div", { className: 'tab-item' },
                            React.createElement("i", { className: "fas fa-file-invoice-dollar" }),
                            React.createElement("label", { htmlFor: "tab2" }, t.priceList)),
                        React.createElement("div", { className: 'tab-item' },
                            React.createElement("i", { className: "fas fa-ruler-triangle" }),
                            React.createElement("label", { htmlFor: "tab3" }, t.floorPlans)),
                        React.createElement("div", { className: 'tab-item' },
                            React.createElement("i", { className: "fas fa-calendar-alt", "aria-hidden": "true" }),
                            React.createElement("label", { htmlFor: "tab4" }, t.salesArrangement)),
                        React.createElement("div", { className: 'tab-item' },
                            React.createElement("i", { className: "fas fa-hand-holding-usd" }),
                            React.createElement("label", { htmlFor: "tab5" }, t.registerOfTransactions))),
                    React.createElement("i", { className: "arrow right-arrow " + (showRightArrow ? '' : 'hidden'), onClick: scrollRight })),
                React.createElement("div", { className: "tab-content" },
                    React.createElement("div", { className: "tab-panel-wrapper", id: "panel1" }, !isEmptyBodyPanels(salesBrochuresPanel) ? renderTable(salesBrochuresPanel) : renderComingSoon()),
                    React.createElement("div", { className: "tab-panel-wrapper", id: "panel2" }, !isEmptyBodyPanels(priceListPanel) ? renderTable(priceListPanel) : renderComingSoon()),
                    React.createElement("div", { className: "tab-panel-wrapper", id: "panel3" }, !isEmptyBodyPanels(floorPlanPanel) ? renderTable(floorPlanPanel) : renderComingSoon()),
                    React.createElement("div", { className: "tab-panel-wrapper", id: "panel4" }, !isEmptyBodyPanels(salesArrangementPanel) ? renderTable(salesArrangementPanel) : renderComingSoon()),
                    React.createElement("div", { className: "tab-panel-wrapper", id: "panel5" }, !isEmptyBodyPanels(registerOfTransactionsPanel) ? renderTable(registerOfTransactionsPanel) : renderComingSoon()))));
    };
    var renderDocumentList = function (tabPanel) { return (React.createElement("div", { className: "tab-panel" },
        React.createElement("div", { className: "data-container" },
            React.createElement("div", { className: "data-row" }, tabPanel.externalLinks.map(function (link, index) { return (React.createElement("a", { key: index, href: link.url, target: "_blank" }, link.text)); })),
            tabPanel.documentContainer.map(function (document) { return (React.createElement("div", { className: "document-list" }, document.documentItemList.map(function (item) { return (React.createElement("div", { className: "document-item", key: imgDomain + item.docLink.url },
                React.createElement("a", { href: imgDomain + item.docLink.url, target: "_blank", className: "document-link" },
                    React.createElement("div", { className: "image-wrapper" },
                        React.createElement("img", { src: imgDomain + item.imageDesc.src, alt: item.imageDesc.alt })),
                    React.createElement("span", null, item.text)))); }))); })))); };
    var renderComingSoon = function () {
        return (React.createElement("div", { className: "data-container" },
            React.createElement("span", null, props.t.comingSoon)));
    };
    var renderTable = function (tabPanel) { return (React.createElement("div", { className: "data-container" },
        React.createElement("div", { className: "data-row" }),
        React.createElement("div", { className: "data-grid" },
            tabPanel.table.header.map(function (header, index) { return (React.createElement("div", { className: "grid-header", key: index }, header)); }),
            tabPanel.table.body.map(function (row, index) { return (React.createElement(react_1.Fragment, { key: index },
                React.createElement("div", { className: "grid-item" }, row[0]),
                React.createElement("div", { className: "grid-item" }, row[1]),
                React.createElement("div", { className: "grid-item" },
                    React.createElement("a", { href: imgDomain + row[2], target: "_blank" }, props.t.download)))); })))); };
    var renderPropertyDetails = function () {
        var renderDetailCell = function (label, values) {
            if (!values) {
                return null;
            }
            // Filter out empty, null, or undefined values
            var validValues = values.filter(function (value) { return value !== null && value !== undefined && value.trim() !== ''; });
            // If all records are empty, null, or undefined, return null
            if (validValues.length === 0) {
                return null;
            }
            return (React.createElement("div", { className: 'c-development__propertyDetails-textcell' },
                React.createElement("div", { className: 'c-development__propertyDetails-textlabel' }, label),
                React.createElement("div", { className: 'c-development__propertyDetails-textvalueContainer' }, validValues.map(function (value, index) { return (React.createElement("div", { key: index }, value)); }))));
        };
        var photo = getPhotos(developmentDetails.assets, DevelopmentPageAssetPurpose_1.AssetPurpose.SubHeroInDetailsPage, 999)[0];
        var constructSchoolNet = function () {
            return constructCombinedCell([[t.primarySchoolNet, developmentDetails.schoolNetOfPrimaraySchool], [t.secondarySchoolNet, developmentDetails.schoolNetOfSecondarySchool]]);
        };
        var constructSizeRange = function () {
            return constructCombinedCell([[t.apartmentSizeRange, developmentDetails.apartmentSizeRange],
                [t.houseSizeRange, developmentDetails.houseSizeRange]]);
        };
        var constructNoOfUnits = function (noOfApartments, noOfHouses) {
            var extractNumberAndUnit = function (str) {
                var match = str.match(/(\d+)\s*(\w+)?/);
                if (match) {
                    return {
                        number: parseInt(match[1], 10),
                        unit: match[2] || ""
                    };
                }
                return { number: null, unit: "" };
            };
            var apartments = extractNumberAndUnit(noOfApartments);
            var houses = extractNumberAndUnit(noOfHouses);
            if (apartments.number !== null && houses.number !== null) {
                var totalUnits = apartments.number + houses.number;
                var unit = apartments.unit || houses.unit; // Use the unit from either input
                return totalUnits + " " + unit;
            }
            return "";
        };
        var constructCombinedCell = function (values) {
            var res = [];
            values.forEach(function (tuple) {
                if (tuple[1]) {
                    res.push(tuple[0] + " " + tuple[1]);
                }
            });
            return res;
        };
        var schoolNet = constructSchoolNet();
        var sizeRange = constructSizeRange();
        var noOfUnits = constructNoOfUnits(developmentDetails.noOfApartments, developmentDetails.noOfHouses);
        return (React.createElement("div", { className: 'c-development__propertyDetailsContainer' },
            React.createElement("div", { className: 'c-development__propertyDetails-texts' },
                React.createElement("div", { className: 'c-development__propertyDetails-texttitle' }, t.propertyDetails),
                React.createElement("div", { className: 'c-development__propertyDetails-textcellWrapper' },
                    renderDetailCell(t.propertyId, [developmentDetails.propertyId]),
                    renderDetailCell(t.noOfUnits, [noOfUnits]),
                    renderDetailCell(t.noOfBlocks, [developmentDetails.noOfBlocks]),
                    renderDetailCell(t.noOfApartments, [developmentDetails.noOfApartments]),
                    renderDetailCell(t.noOfHouses, [developmentDetails.noOfHouses]),
                    renderDetailCell(t.propertySchoolNet, schoolNet),
                    renderDetailCell(t.sizeRange, sizeRange),
                    renderDetailCell(t.storeyHeight, [developmentDetails.storeyHeight]),
                    renderDetailCell(t.district, [developmentDetails.district]),
                    renderDetailCell(t.noOfStoreys, [developmentDetails.noOfStoreys]),
                    renderDetailCell(t.dateOfOccupationPermit, [developmentDetails.occupationPermitDate]),
                    renderDetailCell(t.noOfCarparkingSpace, [developmentDetails.noOfCarpark]))),
            React.createElement("div", { className: 'c-development__propertyDetails-photo' }, React.createElement("picture", { className: 'c-development__picture' },
                React.createElement("source", { srcSet: photo ? photo.urlSmall : '', media: "(max-width: 520px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlMedium : '', media: "(max-width: 768px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlLarge : '' }),
                React.createElement("img", { src: photo ? photo.urlLarge : '', alt: photo ? photo.name : '', loading: "lazy" })))));
    };
    var renderGetInTouch = function () {
        var getInTouch = props.getInTouch;
        var photo = getPhotos(developmentDetails.assets, DevelopmentPageAssetPurpose_1.AssetPurpose.SubHero2InDetailsPage, 999)[0];
        return (React.createElement("div", { className: 'c-development__getInTouchContainer' },
            React.createElement("div", { className: 'c-development__getInTouch-photo' }, React.createElement("picture", { className: 'c-development__picture' },
                React.createElement("source", { srcSet: photo ? photo.urlSmall : '', media: "(max-width: 520px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlMedium : '', media: "(max-width: 768px)" }),
                React.createElement("source", { srcSet: photo ? photo.urlLarge : '' }),
                React.createElement("img", { src: photo ? photo.urlLarge : '', alt: photo ? photo.name : '', loading: "lazy" }))),
            React.createElement("div", { className: 'c-development__getInTouch-texts' },
                React.createElement("div", { className: 'c-development__getInTouch-texttitle' }, t.getInTouch),
                React.createElement("div", { className: 'c-development__getInTouch-companyaddressContainer' },
                    React.createElement("i", { className: "fas fa-map-marker-alt c-development__getInTouch-address-icon" }),
                    React.createElement("div", { className: 'c-development__getInTouch-textcell' }, react_html_parser_1.default(getInTouch.address))),
                React.createElement("div", { className: 'c-development__getInTouch-telandemail' },
                    React.createElement("div", { className: 'c-development__getInTouch-textcell' },
                        t.tel,
                        ": ",
                        getInTouch.tel),
                    React.createElement("div", { className: 'c-development__getInTouch-textcell' },
                        t.email,
                        ": ",
                        getInTouch.email)),
                React.createElement("div", { className: 'c-development__getInTouch-contactusandwhasapp' },
                    React.createElement("div", { className: 'c-development__getInTouch-contactus' },
                        React.createElement(ContactUsButton_1.default, { label: t.contactUs })),
                    React.createElement("div", { className: 'c-development__getInTouch-whasapp' },
                        React.createElement(WhatsAppUsButton_1.default, { label: t.whatsappUs }))),
                React.createElement("div", { className: 'c-development__getInTouch-socialicon-container' },
                    React.createElement("span", null, t.follow),
                    React.createElement("div", { className: "c-socialsharebutton__container" },
                        React.createElement(SocialMediaShareButton_1.default, { platform: SocialMediaShareButton_1.Platform.Instagram, url: getInTouch.linkInstagram }),
                        React.createElement(SocialMediaShareButton_1.default, { platform: SocialMediaShareButton_1.Platform.Facebook, url: getInTouch.linkFacebook }),
                        React.createElement(SocialMediaShareButton_1.default, { platform: SocialMediaShareButton_1.Platform.LinkedIn, url: getInTouch.linkLinkedIn }))))));
    };
    var renderSRPE = function () {
        var replaceOfficialWebsite = function (text, placeholder, value) {
            var regex = new RegExp(placeholder, 'g');
            return text.replace(regex, value);
        };
        var placeholder = '###developmentOfficialWebsite';
        return (React.createElement("div", { className: 'c-development__srpeContainer' }, react_html_parser_1.default(replaceOfficialWebsite(t.srpeInfo, placeholder, developmentDetails.developmentWebsite))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        React.createElement(MegaMenuSide_1.default, null),
        React.createElement("div", { className: 'c-development' },
            renderBanner(),
            React.createElement("div", { className: 'c-development__detailsContainer' },
                renderAddressAndDevelopers(),
                renderpPojectInformation(),
                renderMultimedia(),
                renderDocumentTabs(),
                renderPropertyDetails(),
                renderGetInTouch(),
                renderSRPE()),
            React.createElement(Enquire_1.default, null),
            React.createElement(Bigpopup_1.default, null),
            React.createElement(DetailPopup_1.default, __assign({}, props)))));
};
exports.default = react_redux_1.connect(mapStateToProps, exports.mapDispatchToProps)(development);
